import { Routes, RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { CustomLayoutComponent } from "../layout/custom-layout/custom-layout.component";
import { EqualtecContainer } from "./equaltec-container/EqualtecContainer.component";
import { EqualtecdetailComponent } from "../equaltec-detail/equaltec-detail.component";

const routes: Routes = [
  {
    path: 'arcadocqualita/:linea',
    component: CustomLayoutComponent,
    children: [
      { path: '', component: EqualtecContainer },
    ]

  },
  {
    path: 'arcadocqualita-detail/:id',
    component: CustomLayoutComponent,
    children: [
      { path: '', component: EqualtecdetailComponent },
    ]
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class EqualtecRoutingModule { }
